import React, { useState } from 'react';
import TextInput from './TextInput';
import { Link } from 'react-router-dom';

function ChatPage() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  const handleClearChat = () => {
    setMessages([]);
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (input.trim()) {
      const userMessage = { role: 'user', content: input };
      setMessages([...messages, userMessage]);
      setInput('');
      setIsTyping(true);

      const payload = { messages: [...messages, userMessage] };

      try {
        const response = await fetch('https://us-central1-teapot-441220.cloudfunctions.net/quick_legal', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          const data = await response.json();

          const systemMessages = data.messages.filter((msg) => msg.role === 'system');
          const botResponse = systemMessages[systemMessages.length - 1];

          if (botResponse) {
            setMessages((prevMessages) => [...prevMessages, botResponse]);
          }
        }
      } catch (error) {
        console.error('Error communicating with backend:', error);
      } finally {
        setIsTyping(false);
      }
    }
  };

  // Helper function to render text with bold styling for certain keywords
  const formatMessageContent = (content) => {
    const formattedContent = content
      .replace(/(\*\*)(.*?)\1/g, '<strong>$2</strong>')  
      .replace(/\b(name|your keyword here)\b/gi, '<strong>$&</strong>'); 
    return { __html: formattedContent };
  };

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      {/* Header */}
      <header className="flex items-center justify-between p-4 bg-gradient-to-r from-[#AF40FF] via-[#5B42F3] to-[#00DDEB] text-white font-semibold text-lg">
        <div className="flex items-center">
          <Link to="/" onClick={handleClearChat}>
            <img src="/teaPot.png" alt="Logo" className="w-10 h-10 mr-2" />
          </Link>
          <span>Teapot Chat - Ask about laws and rights</span>
        </div>
        <button
          onClick={handleClearChat}
          className="text-white bg-transparent rounded-lg px-4 py-2 hover:bg-white hover:text-[#5B42F3] transition"
        >
          Clear
        </button>
      </header>

      {/* Main content area for messages and TextInput */}
      <div className="flex flex-col mx-auto max-w-3xl w-full flex-grow overflow-hidden">
        <div className="flex-grow p-4 overflow-y-auto">
          <div className="space-y-4">
            {messages.map((message, index) => (
              <div
                key={index}
                className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}
              >
                <div
                  className={`max-w-full px-4 py-2 rounded-lg break-words whitespace-pre-wrap ${
                    message.role === 'user'
                      ? 'bg-gradient-to-r from-[#AF40FF] via-[#5B42F3] to-[#00DDEB] text-white'
                      : 'bg-gray-300 text-gray-900'
                  }`}
                  dangerouslySetInnerHTML={message.role === 'system' ? formatMessageContent(message.content) : { __html: message.content }}
                ></div>
              </div>
            ))}
            {isTyping && (
              <div className="flex justify-start">
                <div className="max-w-full px-4 py-2 rounded-lg bg-gray-300 text-gray-900 italic">
                  Teapot is typing...
                </div>
              </div>
            )}
          </div>
        </div>

        {/* TextInput positioned at the bottom */}
        <div className="p-4 w-full">
          <TextInput input={input} setInput={setInput} handleSendMessage={handleSendMessage} />
        </div>
      </div>
    </div>
  );
}

export default ChatPage;
